import API from "../config/api.js";

export const InvoiceService = {
    getInvoiceList(search, page=1) {
        return API.get(`api/invoices/list/se=${search}?page=${page}`);
    },

    getPdfInvoice(uuid) {
      return API.get(`api/invoices/pdf/${uuid}`, { responseType: 'arraybuffer' });
    },

    dropMember(uuid) {
      return API.post(`api/invoice/delete/${uuid}`);
    },

    getRevenue(filter){
      return API.get(`api/invoice/revenue-statics/${filter}`);
    },

    getInvoiceInfo(uuid){
      return API.get(`api/invoice/info/${uuid}`);
    },

    createInvoice(data) { 
      return API.post(`api/invoice/create`, data);
    },

    updateInvoice(uuid, data) { 
      return API.post(`api/invoice/edit/${uuid}`, data);
    },
    getProjectInvoiceList(uuid, search, page=1) {
      return API.get(`api/project/${uuid}/invoices/list/se=${search}?page=${page}`);
  },
}